import { Theme, useTheme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { FC } from 'react'

const RadioUncheckedIcon: FC = () => {
    const theme = useTheme()
    return (
        <svg width="18" height="18" viewBox="0 0 20 20">
            <circle
                cx="10"
                cy="10"
                r="9"
                fill={theme.palette.background.paper}
                stroke={theme.palette.grey[300]}
                strokeWidth="1"
            />
        </svg>
    )
}

const RadioCheckedIcon: FC = () => {
    const theme = useTheme()
    return (
        <svg width="18" height="18" viewBox="0 0 20 20">
            <circle
                cx="10"
                cy="10"
                r="9"
                fill={theme.palette.background.paper}
                stroke={theme.palette.primary.main}
                strokeWidth="1"
            />
            <circle
                cx="10"
                cy="10"
                r="5"
                fill={theme.palette.primary.main}
            />
        </svg>
    )
}

export const C1RadioTheme: Components<Theme>['MuiRadio'] = {
    defaultProps: {
        icon: <RadioUncheckedIcon />,
        checkedIcon: <RadioCheckedIcon />,
    },
    styleOverrides: {
        root: ({ theme }) =>
            theme.unstable_sx({
                width: '36px',
                height: '36px',
                marginX: 1,
                borderRadius: C1BorderRadius.large,
                '&:hover': {
                    backgroundColor: theme.palette.primary.extraLight,
                },
                '&:hover svg circle:first-of-type': {
                    stroke: theme.palette.primary.main,
                },
                '&:not(.Mui-checked):hover svg circle:first-of-type': {
                    fill: 'none',
                },
                '&.Mui-disabled svg circle:first-of-type': {
                    stroke: theme.palette.grey[500],
                    fill: 'none',
                },
                '&.Mui-disabled.Mui-checked svg circle:last-of-type': {
                    fill: theme.palette.grey[500],
                },
            }),
    },
}
